export enum OccupationType {
	Unspecified,
	Other,
	Employed,
	Permanent,
	PartTime,
	Entrepreneur,
	FixedTerm,
	Pensioner,
	Unemployed,
	Student,
	SickLeave,
	Retired,
	Housewife,
	TemporarilyEmployed,
	EmployedByHours,
	PublicServant,
	Farmer,
	SelfEmployed,
	Trainee,
	Manager,
	Employment,
	OperatingIncome,
	Capital,
	Child,
	Worker,
	VoluntaryWork,
	Soldier,
	Pupil,
	Director,
	Artisan,
	Merchant,
	SalesAgent,
	TruckOperator,
	Surveyor,
	SelfEmployedOther,
	Doctor,
	Lawyer,
	Architect,
	TaxAccountant,
	Engineer,
	Notary,
	CareTaker,
	SeasonalWorker,
}
